// extracted by mini-css-extract-plugin
export default {"recent":"RecentSearches_recent__EJqix","link":"RecentSearches_link__rCsQF","clear":"RecentSearches_clear__ALvsc"};